import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';
import { FormApplicationSettingsEditView } from './views/FormApplicationSettingsEditView';
import { FormApplicationSettingsInteractions } from './partials/FormApplicationSettingsInteractions';
import { FormApplicationSettingsDefaultView } from './views/FormApplicationSettingsDefaultView';

export type FormApplicationSettingsProps = Views<
  DefaultView<FormApplicationSettingsDefaultView> & EditView<FormApplicationSettingsEditView>
>;

function FormApplicationSettings(props: FormApplicationSettingsProps) {
  return <FormApplicationSettingsInteractions {...props} />;
}

export const FormApplicationSettingsBlock = asFetchableBlock(
  FormApplicationSettings,
  BlockType.formapplicationSettings
);
export type FormApplicationSettingsBlock = ComponentProps<typeof FormApplicationSettings>;
